import React from 'react';
import { FormField } from '../../../types/formBuilder';
import { DropdownWithImagePreview } from '../DropdownWithImagePreview';

interface DropdownWithImageInputProps {
  field: FormField;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const DropdownWithImageInput: React.FC<DropdownWithImageInputProps> = ({
  field,
  value,
  onChange,
  disabled = false
}) => {
  return (
    <DropdownWithImagePreview
      options={field.imageOptions || []}
      value={typeof value === 'object' ? '' : (value || '')}
      onChange={onChange}
      placeholder={field.placeholder}
      allowCustomValue={field.allowCustomValue || false}
      customValueLabel={field.customValueLabel || "Enter Custom Value"}
      customButtonLabel={field.customButtonLabel || "Use Custom Value"}
      customInputPlaceholder={field.customInputPlaceholder || "Type your custom value..."}
      disabled={disabled}
    />
  );
};